import React from 'react';
import Hero         from '../components/Hero';
import Magazines    from '../components/Magazines';
import News         from '../components/News';
import CoverStories from '../components/CoverStories';
import Profiles     from '../components/Profiles';
import Articles     from '../components/Articles';
import Trends       from '../components/Trends';
import Brands       from '../components/Brands';
import Newsletter   from '../components/Newsletter';

export default function Home() {
  return (
    <>
      <Hero />
      <Magazines />
      <News />
      <CoverStories />
      <Profiles />
      <Articles />
      <Trends />
      <Brands />
      {/* <Newsletter /> */}
    </>
  );
}
